import { hasValue } from '@frontend/sports/common/core/utils/extended-types';
import { Widget, WidgetType } from '@frontend/sports/types/components/widget';
import { ComposableWidgetPayload } from '@frontend/sports/types/components/widget/types';
import { uniqBy } from 'lodash-es';

export function widgetsToWidgetTypes(widgets: Widget<unknown>[] | undefined) {
    let widgetTypes = widgets?.map((widget) => widget.type);
    const composableWidget = widgets?.find((widget) => widget.type === WidgetType.Composable);
    if (composableWidget) {
        const composableWidgetPayload = (composableWidget.payload ?? {}) as ComposableWidgetPayload;
        const childWidgets = uniqBy(
            composableWidgetPayload.items?.flatMap((item) => item.children),
            (child) => child.type,
        ).map((child) => child.type);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        widgetTypes = [...childWidgets, ...widgetTypes!];
    }
    return widgetTypes?.filter(hasValue);
}
